import { memo } from "react";

import Typography from "ds/components/Typography";
import { ManagedUserGroup } from "types/generated";
import Timestamp from "components/Timestamp";

type IdpGroupLastLoginCellProps = {
  group: ManagedUserGroup;
};

const IdpGroupLastLoginCell = ({ group }: IdpGroupLastLoginCellProps) => {
  if (!group.lastLoginTime)
    return (
      <Typography tag="span" variant="p-body3">
        -
      </Typography>
    );

  return <Timestamp timestamp={group.lastLoginTime} />;
};

export default memo(IdpGroupLastLoginCell);
